import type { Type } from '@angular/core';
import type { AppQuippyDialog } from './dialog';

export async function loadQuippyDialog(): Promise<Type<AppQuippyDialog>> {
    const module = await import('./dialog');
    return module.AppQuippyDialog;
}
